import { ModeToggle } from '@/components/mode-toggle'

const Footer = () => {
  return (
    <footer className="py-8 w-full relative z-10 overflow-hidden">
      <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
        <div className="text-sm leading-5 text-gray-400">
          © {new Date().getFullYear()} blogging.dev
        </div>
        <ModeToggle />
      </div>
    </footer>
  )
}

export default Footer
